
// src/web/components/diary-fields.jsx

import React from 'react'
import ReactDOM from 'react-dom'
import { translate } from 'react-i18next'
import {
  CardMedia,
  CardText,
} from 'react-toolbox/lib/card'
import {
  List,
  ListItem,
  ListItemText,
  ListDivider,
  ListItemContent,
} from 'react-toolbox/lib/list'
import fieldListItemTheme from './themes/field-list-item.css'
import FIELD_ICONS from '../../helpers/field-icons'
import { urlRegex,textUrl } from '../../helpers/url-regexp'
import numRegex from '../../helpers/number-regexp'
import moment from 'moment'
import _ from 'lodash'

const Regex = urlRegex()

const EmailRegex = urlRegex({ email: true });
const PhoneRegex = urlRegex({ phoneNumber: true });

class DiaryFields extends React.Component {
  getHTMLText = (value) => {
    return <span dangerouslySetInnerHTML={{ __html: this.convertHighlight(value) }} />;
  }
  
  renderLink = (text, i) => {
    // Return the link on the URL, Email, Phone Number case
    if (Regex.test(text)) {
      return textUrl(text).map((value, i) => (
        Regex.test(value) ? <a key={i} href={value} target="_blank" rel="noopener noreferrer">{this.getHTMLText(value)}</a> : this.getHTMLText(value)
      ));
    }
    if (EmailRegex.test(text)) {
      return <a key={i} href={`mailto:${text}`}>{this.getHTMLText(text)}</a>;
    }
    if (PhoneRegex.test(text)) {
      return <a key={i} href={`tel:${text}`}>{this.getHTMLText(text)}</a>;
    }
    
    return this.getHTMLText(text);
  }
  
  convertHighlight = (text) => {
    const query = this.props.query;
    let searchHits = '';
    if (query && query.query) {
      const value = query.query;
      // Split by both spaces and commas, then extract values after '='
      searchHits = value.split(/[\s,]+/).map(item => item.includes('=') ? item.split('=')[1] : item);
    }

    if(text && searchHits) {
      _.each(searchHits, (hit) => {
        const escapedHit = hit.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        const regexPattern = new RegExp(`(?!<[^>]*?)(${escapedHit})(?![^<]*?>)`, 'gi');
        text = text.replace(regexPattern, `<em>$1</em>`);
      });
    }

    return text;
  }

  render() {
    const {
      t,
      fields,
      query,
    } = this.props

    if (!fields || fields.length == 0)
      return null

    return (
      <List>
        {_.map(fields, (field, i)=> 
          (field.type == 'text' &&
            <ListItem key={i} theme={fieldListItemTheme} ripple={false}>
              <ListItemContent theme={fieldListItemTheme}>
                <ListItemText primary theme={fieldListItemTheme}>
                  {field.name}
                </ListItemText>
                <ListItemText theme={fieldListItemTheme}>
                  {this.getHTMLText(field.value)}
                </ListItemText>
              </ListItemContent>
            </ListItem> ||
            <ListItem key={i} theme={fieldListItemTheme}
              caption={field.name}
              legend={
                field.type == 'date' && (field.value && this.getHTMLText(moment(field.value).format('YYYY-MM-DD')) || t('label:未入力')) ||
                field.type == 'numeric' && this.getHTMLText(numRegex(field.value)) || 
                field.type === 'string' && this.renderLink(field.value, i) || 
                this.getHTMLText(field.value)
              }
              ripple={false} />)
        )}
      </List>
    )
  }
}

export default translate()(DiaryFields)



// WEBPACK FOOTER //
// ./src/web/components/diary-fields.jsx